/**
 * Get domain name of website
 * @returns
 */
import { getLocation } from '@praxis/runtime-utils/getLocation'

export const getDomainName = () => {
  const loc = getLocation?.()
  const hostname = loc?.hostname

  if (!hostname) return '' // prevents crash

  return hostname.substring(
    hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1,
  )
}
/**
 * Checks if the current domain is 'partnersonline.com'.
 */
export const isExternalDomain = () => {
  const hostname = getLocation()?.hostname || ''
  return hostname.endsWith('.partnersonline.com')
}

export const isTarget = (url) => {
  url = url ?? getLocation().href
  // return /(localhost|^([^/]+:)?\/{2,3}[^/]+?(\.target\.com)(:|\/|$))/i.test(url)
  return /(^([^/]+:)?\/{2,3}[^/]+?(\.target\.com)(:|\/|$))/i.test(url)
}
export const isProd = (url) => {
  url = url ?? getLocation().href
  return /https?:\/\/(itemhub(\.(prod))?)\.(target|partnersonline)\.com/.test(
    url,
  )
}

// To Find, IS Itemhub Internal Domain
const isItemHubDomainInternal = () => {
  const regex =
    /^https:\/\/itemhub(?:-[a-zA-Z0-9]+)?\.(?:dev|prod)\.target\.com(?:\/.*)?$/i
  return regex.test(getLocation()?.href ?? '')
}

// To Find, IS Itemhub External Domain
const isItemHubDomainExternal = () => {
  const regex =
    /^https:\/\/itemhub\.(?:[a-zA-Z]+\.)?partnersonline\.com(?:\/.*)?$/i
  return regex.test(getLocation()?.href ?? '')
}

// To find the app is part of Itemhub
export const isItemHub = () =>
  isItemHubDomainInternal() || isItemHubDomainExternal()
